"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTitle = exports.useTitle = void 0;

var _react = _interopRequireDefault(require("react"));

var _isNode = _interopRequireDefault(require("./isNode"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var currentTitle = '';
/**
 * This hook will set the window title, when a component gets mounted.
 * When the component gets unmounted, the previously used title will be restored.
 * @param {string} inString
 */

var useTitle = function useTitle(inString) {
  currentTitle = inString;

  if (_isNode.default) {
    return;
  }

  _react.default.useEffect(function () {
    var previousTitle = document.title;
    document.title = inString;
    return function () {
      document.title = previousTitle;
    };
  });
};
/**
 * Returns the current window title to be used in a SSR context
 * @returns {string}
 */


exports.useTitle = useTitle;

var getTitle = function getTitle() {
  return currentTitle;
};

exports.getTitle = getTitle;